import {
  Chart,
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PieController,
  PointElement,
  TimeScale,
  Tooltip,
} from "chart.js";

import "chartjs-adapter-dayjs-3";

Chart.register(ArcElement, BarController, BarElement, CategoryScale, Legend, LinearScale, LineController, LineElement, PieController, PointElement, TimeScale, Tooltip);

window.addEventListener('load', () => { 
  if (document.body.getAttribute('data-disable-animations')) {
    Chart.defaults.animation = false
  }
});

export { Chart };
